import { useTranslation } from 'react-i18next';
import { Alert } from '@/shared/ui';
import { useAgendaParams } from '@/shared/navigation/react/useAgendaParams';
import { useWindowTitle } from '@/shared/windowing';
import { DETAIL_QUERY_STALE_TIME_MS } from '@/shared/lib/queryClient';
import { useGetProductsPlaceholderSubcategory } from '@/api/generated/products-placeholder-subcategories/products-placeholder-subcategories';
import { subcategoryDetailAgenda } from './subcategoryDetailAgenda';
import { SubcategoryDetailView } from './SubcategoryDetailView';
import { emptySubcategoryFormValues, fromGetSubcategoryResponse } from './subcategoryFormSchema';

interface SubcategoryDetailPageProps {
  layerId: string;
}

/** Thin loader: vyřeší parametr agendy a (v editaci) načtení detailu subkategorie. */
export function SubcategoryDetailPage({ layerId }: SubcategoryDetailPageProps) {
  const { t } = useTranslation('venua-planner');
  const { open } = useAgendaParams(subcategoryDetailAgenda, layerId);
  const subcategoryId = open.subcategoryId;
  const isEdit = subcategoryId != null;

  const detailQuery = useGetProductsPlaceholderSubcategory(subcategoryId ?? '', {
    query: { enabled: isEdit, staleTime: DETAIL_QUERY_STALE_TIME_MS },
  });

  // Dynamický název okna (taskbar / historie / hlavička) = název subkategorie (v editaci).
  useWindowTitle(detailQuery.data?.name);

  if (isEdit && detailQuery.isLoading) {
    return (
      <p className="text-phx-text-muted text-phx-sm p-phx-5">{t('schemes.subcategory.loading')}</p>
    );
  }
  if (isEdit && detailQuery.isError) {
    return (
      <div className="p-phx-5">
        <Alert severity="error" title={t('schemes.subcategory.loadErrorTitle')}>
          {t('schemes.subcategory.loadErrorDescription')}
        </Alert>
      </div>
    );
  }

  return (
    <SubcategoryDetailView
      layerId={layerId}
      subcategoryId={subcategoryId}
      initialValues={
        detailQuery.data
          ? fromGetSubcategoryResponse(detailQuery.data)
          : emptySubcategoryFormValues()
      }
    />
  );
}
